<template>
  <section class="container">
    <div class="main">
      <div class="header">
        <h2>Edit Order</h2>
        <div class="btn">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleConfirm">Confirm</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div
          class="box">

          <div class="form form1">
            <div class="item">
              <span class="item-title">Last Name</span>
              <el-form-item
                ref="isrd_lst_nm"
                prop="isrd_lst_nm">
                <v-input
                  v-model="formData.isrd_lst_nm"
                  disabled
                  uppercase />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">First Name</span>
              <el-form-item
                ref="isrd_fst_nm"
                prop="isrd_fst_nm">
                <v-input
                  v-model="formData.isrd_fst_nm"
                  disabled
                  uppercase></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Mobile Number</span>
              <el-form-item
                ref="mobile_no"
                prop="mobile_no">
                <v-input
                  v-model="formData.mobile_no"
                  disabled
                  uppercase></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Email</span>
              <el-form-item
                ref="email"
                prop="email">
                <v-input
                  v-model="formData.email"
                  disabled
                  uppercase></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Registration Mark</span>
              <el-form-item
                ref="rgtn_no"
                prop="rgtn_no">
                <v-input
                  v-model="formData.rgtn_no"
                  :uppercase="true"
                  maxlength="8"
                  type="text"/>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Need the professional licensing agency documents services?</span>
              <el-form-item
                ref="need_ind"
                prop="need_ind">
                <v-radio-group
                  v-model="formData.need_ind"
                  :list="yesNoOptions"/>
              </el-form-item>
            </div>
          </div>

        </div>
      </el-form>
      <div class="footer">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <v-button
          green
          @click="handleConfirm">Confirm</v-button>
      </div>
    </div>
    <aside>
      <div class="box-remark">
        <span class="title">Remarks</span>
        <div class="remarks-container">
          <div
            v-for="(item, index) in remarkLogsData"
            :key="index"
            class="remark-box">
            <div class="remark-header">
              <span>{{ item.agent }}</span>
              <span>{{ item.created_at }}</span>
            </div>
            <p>{{ item.message }}</p>
          </div>
        </div>
        <div class="remark-add">
          <v-input
            v-model="message"
            class="mg-b-15"
            append="Add"
            @handlerAppend="handlerRemark"/>
        </div>
      </div>
    </aside>
    <send-email-sms
      ref="send-email-sms"
      :form="customer_profile"
      :is-edit="true"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @skip="handlerSkip"
      @send="handlerSend" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {addHzmbRemark, editHzmbOrder} from '@/api/hzmb'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'

export default {
  name: 'SubscribeMembership',
  components:{
    SendEmailSms
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    from:{
      type:Object,
      default:()=>({})
    },
    customer:{
      type:Object,
      default:()=>({})
    },
    remark:{
      type:Array,
      default:()=>([])
    },
    id:{
      type:[Number,String],
      default:''
    },
  },
  data () {
    return {
      formData:{
        isrd_lst_nm:'',
        isrd_fst_nm:'',
        mobile_no:'',
        email:'',
        rgtn_no:'',
        need_ind:''
      },
      message:'',
      remarkList: [],
      is_send:0,
      extraRules: {
        need_ind: [
          {required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur']},
        ],
      }
    }
  },
  computed:{
    customer_profile(){
      let customer_profile = this.customer||{}
      let {isrd_lst_nm,isrd_fst_nm} = this.formData
      let {isrd_nm,nick_name} = customer_profile
      if(!isrd_nm) {
        customer_profile.isrd_lst_nm = isrd_lst_nm
        customer_profile.isrd_fst_nm = isrd_fst_nm
      }
      if(nick_name){
        customer_profile.isrd_nm = nick_name
      }
      return customer_profile
    },
    remarkLogsData(){
      return this.remarkList||[]
    },
    customerId() {
      return this.$route.query.customer_id
    },
    emailListTitle(){
      let {success_upgraded_list_title}  = this.form||{}
      return success_upgraded_list_title
    },
    emailTitle(){
      let {success_upgraded_title}  = this.form||{}
      return success_upgraded_title
    },
    initContent(){
      let {success_upgraded_data}  = this.form||{}
      return success_upgraded_data
    },

  },
  watch:{
    from:{
      immediate:true,
      handler(val){
        Object.keys(this.formData).some(key=>{
          if(val&&val[key]){
            this.formData[key] = val[key]
          }
        })
      }
    }
  },
  mounted(){
    this.remarkList = this.remark
  },
  methods: {
    handlerSkip(){
      let params ={
        content:'',
        is_send:0
      }
      this.handleSubscribeSend(params)
    },
    handlerSend(content){
      let params ={
        content:content,
        is_send:1
      }
      this.handleSubscribeSend(params)
    },
    handleCancel(){
      this.$emit('cancel')
    },
    handlerRemark() {
      if (this.message) {
        this.network().addAccountRemark()
      }
    },
    handleConfirm(){

      this.$refs.form.validate( (valid) => {
        if (valid) {
          // 額外參數
          this.network().editHzmbOrder()
        }

      })
    },
    network() {
      return {
        editHzmbOrder: async (params) => {
          let {rgtn_no,need_ind} = this.formData
          const { data } = await editHzmbOrder({
            id: this.id,
            rgtn_no,
            need_ind
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.$emit('success')
        },
        addAccountRemark: async () => {
          const {data} = await addHzmbRemark({
            id: this.id,
            message: this.message
          })
          this.message = ''
          this.remarkList.unshift(data)
        }
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.container{
  display: flex;
  padding: 0 70px;
  margin-top: 20px;
  min-height: calc(100vh - 150px);
  .main{
    margin-right: 30px;
    flex: 1;
    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      h2{
        padding: 0;
        font-weight: 600;
        font-size: 20px;
        color: #24292E;
      }
    }
    .box{
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 30px;
      .form{
        .item{
          .item-title{
            font-weight: 600;
            font-size: 14px;
            color: #24292E;
            margin-bottom: 8px;
            display: inline-block;
          }
          & + .item{
            margin-top: 20px;
          }
        }
      }
      .form1, .formData{
        width: 330px;
      }
      .tips{
        padding-left: 24px;
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #24292E;
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
    }
  }
  aside{
    width: 280px;
    .box-remark{
      .title{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
      }
      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
      }
    }
  }
  /deep/.birth{
    .year{
      width: 140px;
      margin-right: 0;
    }
  }
  /deep/.el-radio-group{
    display: flex;
    flex-direction: column;
  }
  /deep/.el-radio{
    font-weight: 600;
    font-size: 14px;
    color: #24292E;
    & + .el-radio{
      margin-top: 4px;
    }
  }
}
</style>
